module.exports = __webpack_public_path__ + "static/media/google6.6d17356b.png";